import { Env } from 'infra/env'
import { PayoutReviewViewModel } from 'payouts/admin/review/PayoutReviewViewModel'
import { PayoutsAdminModulePorts } from './ports'
import { PayoutReviewStore } from './PayoutReviewStore'
import { AdminPayoutHistoryStore } from './AdminPayoutHistoryStore'
import { AdminTransactionHistoryViewModel } from './transaction-history/AdminTransactionHistoryViewModel'

/**
 * Root View Model for the Payouts admin module.
 */
export class PayoutsAdminRootViewModel {
  readonly reviewVm = new PayoutReviewViewModel(
    this.payoutReviewStore,
    this.adapter,
  )

  readonly historyVm = new AdminTransactionHistoryViewModel(
    this.adminPayoutHistoryStore,
    this.adapter,
  )

  constructor(
    private env: Env,
    private payoutReviewStore: PayoutReviewStore,
    private adminPayoutHistoryStore: AdminPayoutHistoryStore,
    private adapter: PayoutsAdminModulePorts,
  ) {}
}
